import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux'
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import SyncIcon from '@mui/icons-material/Sync';
import {Tooltip} from "@mui/material";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import SortIcon from '@mui/icons-material/Sort';
import {toast} from "react-toastify";
import {Link, useNavigate} from "react-router-dom";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import {Head, Loading} from "../index";
import Api from "../../utils/api";
import {landingAction} from "../../actions";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import {FETCH_LANDING, TOGGLE_CHECKED} from "../../types";
import CreateIcon from "@mui/icons-material/Create";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import RemoveCircleOutlineOutlinedIcon from "@mui/icons-material/RemoveCircleOutlineOutlined";

const LandingPage = ( props ) => {

    const [sort_field, setSortField] = useState('id');
    const [sort_type, setSortType] = useState('desc');
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [form , setForm] = useState({})
    const [data , setData] = useState({})

    const history = useNavigate()


    useEffect(() => {
        handleRequest();
    }, [sort_field, sort_type]);


    const handleRequest = () => {
        setLoading(true);

        new Api().get('/landing/get').then((response) => {
            setLoading(false);

            setData(response)
        })
    };



    const handleSubmit = (event) => {
        event.preventDefault();

        setLoading(true);
        new Api().post('/landing/store',{
            "form": "landing_page_store",
            "title": form.title
        }, false).then((response) => {
            if (typeof response !== "undefined") {
                if (response.status) {
                    history(`/landing_page/create/${response?.details?.id}`)
                    setOpen(false);
                } else {
                    toast.error(response.msg);
                }
            }
            setLoading(false);
        })

    }

    const handleDelete = (id) => {

        setLoading(true);


        new Api().delete(`/landing/destroy/${id}`, false).then((response) => {
            if (typeof response !== "undefined") {
                if (response.status) {
                    setData(response)
                    toast.success("سهند مسیج بذار");
                } else {
                    toast.error(response.msg);
                }
            }
            setLoading(false);
        })
    }

    const handleUpdate = (id) => {

        setLoading(true);


        new Api().put(`/landing/update/${id}`, false).then((response) => {
            if (typeof response !== "undefined") {
                if (response.status) {
                    setData(response)
                    toast.success("سهند مسیج بذار");
                } else {
                    toast.error(response.msg);
                }
            }
            setLoading(false);
        })
    }


    return(
        <Container>
            <Head data={{ 'link': '/', 'title': 'لندینگ پیج', 'description': 'لندینگ پیج را به صورت دلخواه انتخاب کنید' }} />
            <div style={{ display: 'flex', direction: 'row', justifyContent: 'flex-end'}}>
                <Tooltip title="افزودن">
                    <IconButton onClick={() => setOpen(true)}>
                            <AddCircleOutlineIcon />
                        </IconButton>
                </Tooltip>
                <Dialog fullWidth={true} open={open} aria-labelledby="form-dialog-title">
                    <form dir='rtl' onSubmit={handleSubmit}>
                        <DialogTitle id="form-dialog-title">ساخت لندینگ پیج جدید</DialogTitle>
                        <DialogContent>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <TextField
                                        label="عنوان"
                                        variant="outlined"
                                        margin='dense'
                                        fullWidth
                                        name='title'
                                        value={form.title}
                                        onChange={(e) => form.title = e.target.value}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        helperText='عنوان پیج'
                                    />
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button color="primary" onClick={() => setOpen(false)}>
                                انصراف
                            </Button>
                            <Button disabled={loading} color="primary" autoFocus type='submit'>
                                ارسال اطلاعات
                            </Button>
                        </DialogActions>
                    </form>
                </Dialog>
                <Tooltip title="سینک" onClick={() => handleRequest()}>
                    <IconButton>
                        <SyncIcon />
                    </IconButton>
                </Tooltip>
            </div>
            <>
                <div style={{ overflowX: 'auto'}}>
                    <table className='table'>
                        <thead>
                        <tr>
                            <th onClick={() => {setSortField('id'); setSortType(sort_type === 'asc' ? 'desc' : 'asc')}}>#&nbsp;{ sort_field === 'id' ? (sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                            <th>عنوان</th>
                            <th>نویسنده</th>
                            <th>عملیات</th>
                        </tr>
                        </thead>
                        <tbody>
                        {data?.details?.data?.map((entity, index) => {
                            return(
                                <tr key={index}>
                                    <td>{entity?.id}</td>
                                    <td>{entity?.title}</td>
                                    <td>{entity?.created_by?.name}</td>
                                    <td>
                                        <Tooltip title="ویرایش">
                                            <Link to={`/landing_page/create/${entity?.id}`}>
                                                <IconButton>
                                                    <CreateIcon />
                                                </IconButton>
                                            </Link>
                                        </Tooltip>
                                        <Tooltip title="حذف">
                                                <IconButton onClick={() => handleDelete(entity?.id)}>
                                                    <RemoveCircleOutlineOutlinedIcon color={"red"}/>
                                                </IconButton>
                                        </Tooltip>
                                    </td>
                                </tr>
                            );
                        })}
                        </tbody>
                    </table>
                </div>
                {loading && <Loading />}
            </>
        </Container>
    );
}


const mapStateToProps = state => ({
    landingsReducer: state.landingsReducer,

});

const mapDispatchToProps = (dispatch) => ({
    fetchLandings: (object) => {
        dispatch(landingAction.fetchLandings(object))
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(LandingPage)
